import React from 'react'
import styled from 'styled-components'
import ButtonTC from '../../../../components/button-tc/button-tc';
import { ArrowIosForwardOutline } from '@styled-icons/evaicons-outline'
import { device } from '../../../../config/theme/breakpoints';
import { RecordCircleFill } from '@styled-icons/bootstrap'
import { ThreeDotsVertical } from '@styled-icons/bootstrap'
import { LocationDot } from '@styled-icons/fa-solid'
import { Clock } from '@styled-icons/bootstrap'

const GeneralCenter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const ContainerItem = styled(GeneralCenter)`
    width: 100%;
    background: #F2F2F2;
    padding: 20px 30px;
    margin-top: 20px;
    margin-bottom: 0px;
    flex-wrap: wrap;
    border-radius: 15px;
`

const ContainerTop = styled(GeneralCenter)`
    width: 100%;
    justify-content: space-between;
    margin-bottom: 15px;
    align-items: center;
    flex-direction: column;

    @media ${device.tablet}{
        flex-direction: row;
    }
`
const Divider = styled.div`
    width: 100%;
    background: ${p => p.theme.palette.text.grayLight};
    height: 2px;
    border-radius: 50px;
`

const ContainerBottom = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    margin-top: 20px;

    @media ${device.tablet}{
        flex-direction: row;
    }
`

const ContainerHeader = styled.div`
    > h2 {
        color: ${p => p.theme.palette.primary.main};

        > span {
            color: ${p => p.theme.palette.text.gray};
            font-size: 20px;
        }
    }
`
const ContainerFeatureHeader = styled.div`
    color: ${p => p.theme.palette.text.gray};
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;

    > p {
        margin: 0;
    }
    > h3 {
        color: ${p => p.theme.palette.text.gray} !important;
        margin: 0 !important;
    }

    @media ${device.tablet}{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 0;
    }
`

const ContainerPrice = styled.div`
    color: ${p => p.theme.palette.text.gray};
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;

    > p {
        margin: 0;
    }
    > h2 {
        color: ${p => p.theme.palette.text.secondary} !important;
        margin: 0;
    }

    @media ${device.tablet}{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 0;
    }
`


const ContainerDestiny = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    
    @media ${device.tablet}{
        width: 70%;
    }
`
const ContainerButton = styled.div`
    width: 100%;
    margin-top: 30px;
    
    @media ${device.tablet}{
        width: 30%;
        margin-top: 0;
    }
`

const ContainerIcons = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 10px;
    margin-right: 5px;

    > svg {
        max-width: 10px;

        :nth-child(1){
            color: ${p => p.theme.palette.text.secondary};
        }
        :nth-child(2){
            color: ${p => p.theme.palette.text.primary};
            margin-top: 5px;
            margin-bottom: 5px;
        }
        :nth-child(3){
            color: ${p => p.theme.palette.text.primary};
        }
    }
`
const ContainerText = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    > div {
        font-size: 12px;
    }
    
    > div b {
        margin-right: 10px;
    }
`
const ContainerDuration = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    
    > svg {
        max-width: 12px;
        color: ${p => p.theme.palette.text.primary};
        margin-right: 5px;
    }

    > p {
        font-size: 12px;
        color: ${p => p.theme.palette.text.gray};
    }
`

const ContainerImage = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 15px;
    justify-content: center;
`
const ItemImage = styled.div`
    width: 30px;
    height: 30px;
    padding: 4px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${p => p.theme.palette.text.grayLight};

    > img{
        max-width: 15px;
        color: ${p => p.theme.palette.text.gray};
    }
`

export interface IOption {
    id: number,
    icon: string,
}

export interface IServiceProps{
    type: string;
    inclination: string;
    seatingNumber: string;
    price: string;
    initTime: string;
    arrivalTime: string;
    fromCity: string;
    toCity: string;
    time: string;
    listOptions: IOption[];
    onClick?: () => void;
}

const TicketItem: React.FunctionComponent<IServiceProps> = ({
    type,
    inclination,
    seatingNumber,
    price,
    initTime,
    arrivalTime,
    fromCity,
    toCity,
    time,
    listOptions = [],
    onClick = () => console.log
}) => {
  return (
    <ContainerItem>
        <ContainerTop>
            <ContainerHeader>
                <h2>{type} <span>{inclination}</span></h2>
            </ContainerHeader>
            <ContainerFeatureHeader>
                <h3>{seatingNumber}</h3>
                <p>ASIENTOS</p>
            </ContainerFeatureHeader>
            <ContainerPrice>
                <p>Ida desde</p>
                <h2>S/ {price}</h2>
            </ContainerPrice>
        </ContainerTop>
        <Divider />
        <ContainerBottom>
            <ContainerDestiny>
                <ContainerIcons>
                    <RecordCircleFill />
                    <ThreeDotsVertical />
                    <LocationDot />
                </ContainerIcons>
                <ContainerText>
                    <div><b>{initTime}</b>{fromCity}</div>
                    <div><b>{arrivalTime}</b>{toCity}</div>
                </ContainerText>
                <ContainerDuration>
                    <Clock />
                    <p>Duración: {time} Aproximadamente</p>
                </ContainerDuration>
            </ContainerDestiny>
            <ContainerButton>
                <ButtonTC
                    text='Ver destinos ahora'
                    icon={<ArrowIosForwardOutline />}
                    buttonStyle='secondary'
                    onClick={onClick}
                />
                <ContainerImage>
                    {listOptions.map(feature => (
                        <ItemImage>
                            <img key={feature.id} src={feature.icon} alt='feature'/>
                        </ItemImage>
                    ))}
                </ContainerImage>
            </ContainerButton>
        </ContainerBottom>
    </ContainerItem>
  )
}

export default TicketItem